import TopHeader from "components/top/TopHeader";
import React from "react";
import { Helmet } from "react-helmet-async";

const E404: React.FC = () => {
  return (
    <div className="w-full">
      <Helmet>
        <title>404</title>
      </Helmet>
      <TopHeader />

      <div className="flex justify-center py-24">
        <div className="text-2xl font-bold">
          申し訳ございません。お探しのページは見つかりませんでした。
        </div>
      </div>
    </div>
  );
};
export default E404;
